import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as e } from "../mixins/widget.js";
import { connectPagination as a } from "instantsearch.js/es/connectors/index.js";
import { createPanelConsumerMixin as i } from "../mixins/panel.js";
export default {
  name: "AisPagination",
  mixins: [t({
    name: "Pagination"
  }), e({
    connector: a
  }, {
    $$widgetType: "ais.pagination"
  }), i()],
  props: {
    padding: {
      type: Number,
      default: void 0,
      validator: function validator(t) {
        return t > 0;
      }
    },
    totalPages: {
      type: Number,
      default: void 0,
      validator: function validator(t) {
        return t > 0;
      }
    },
    showFirst: {
      type: Boolean,
      default: !0
    },
    showLast: {
      type: Boolean,
      default: !0
    },
    showNext: {
      type: Boolean,
      default: !0
    },
    showPrevious: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        padding: this.padding,
        totalPages: this.totalPages
      };
    }
  },
  emits: ["page-change"],
  methods: {
    refine: function refine(t) {
      var e = Math.min(Math.max(t, 0), this.state.nbPages - 1);
      this.state.refine(e), this.$emit("page-change", e);
    }
  }
};